@if (request) {
  <div class="req-avatar">
    <app-avatar class="avatar-md w-24 flex-none mr-7"
                [url]="request.avatar?.url ?? ''"
                [name]="request.fullName"
    ></app-avatar>
  </div>
  <div class="req-info">
    <h3 class="name" [innerText]="request.fullName"></h3>
    <p class="username" [innerText]=" '@' + request.userName"></p>
  </div>
  <div class="actions">
    <div class="more">
      @if (request) {
        <button class="friends-menu-button" (click)="onMenuClick($event)" mat-button [matMenuTriggerFor]="menu">
          <app-icon class="icon" name="heroEllipsisHorizontal"></app-icon>
        </button>
        <mat-menu class="actions" #menu="matMenu">
          <button (click)="shareTo($event, request.id)" class="menu-item default" mat-menu-item>Share back with them
          </button>
          <button (click)="removeRequest($event, request.id)" class="menu-item delete-item" mat-menu-item>Delete
            request
          </button>
        </mat-menu>
      }
    </div>
  </div>
}
